import type { CSSProperties, HTMLAttributes, ReactNode } from 'react'
import styles from './Grid.module.css'

export type GridGap = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'

const GAP_MAP: Record<GridGap, string> = {
  xs: 'var(--nexus-space-xs)',
  sm: 'var(--nexus-space-sm)',
  md: 'var(--nexus-space-md)',
  lg: 'var(--nexus-space-lg)',
  xl: 'var(--nexus-space-xl)',
  '2xl': 'var(--nexus-space-2xl)',
}

export interface GridProps extends HTMLAttributes<HTMLDivElement> {
  cols?: number
  colsMd?: number
  colsSm?: number
  gap?: GridGap
  children: ReactNode
}

export function Grid({
  cols = 1,
  colsMd,
  colsSm,
  gap = 'md',
  children,
  className,
  style,
  ...props
}: GridProps) {
  const classes = [styles.grid, className].filter(Boolean).join(' ')

  const gridStyle = {
    '--grid-cols': cols,
    '--grid-cols-md': colsMd ?? Math.min(cols, 2),
    '--grid-cols-sm': colsSm ?? 1,
    '--grid-gap': GAP_MAP[gap],
    ...style,
  } as CSSProperties

  return (
    <div className={classes} style={gridStyle} {...props}>
      {children}
    </div>
  )
}
